import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Tickets from "./tickets";
import Login from "./login";

function App() {
  const [authFlag, setAuthFlag] = useState(() => localStorage.getItem("auth"));

  useEffect(() => {
    const stored = localStorage.getItem("auth");
    if (stored && !authFlag) {
      setAuthFlag(stored);
    }
  }, [authFlag]);

  const handleLoginSuccess = (newToken) => {
    setAuthFlag(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem("auth");
    setAuthFlag(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            authFlag === "1" ? (
              <Navigate to="/tickets" replace />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />
        <Route
          path="/tickets"
          element={
            authFlag === "1" ? (
              <Tickets onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="*"
          element={
            <Navigate to={authFlag === "1" ? "/tickets" : "/login"} replace />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
